import React from 'react';
import { useParams } from 'react-router-dom';
import DiscountForm from './DiscountForm';

export default function EditDiscount() {
  let { id } = useParams();
  return <DiscountForm id={id} />;
}
